"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TableHeader: function() {
        return _index.TableHeader;
    },
    renderTableHeader_unstable: function() {
        return _index.renderTableHeader_unstable;
    },
    tableHeaderClassName: function() {
        return _index.tableHeaderClassName;
    },
    tableHeaderClassNames: function() {
        return _index.tableHeaderClassNames;
    },
    useTableHeaderStyles_unstable: function() {
        return _index.useTableHeaderStyles_unstable;
    },
    useTableHeader_unstable: function() {
        return _index.useTableHeader_unstable;
    }
});
const _index = require("./components/TableHeader/index");
